import { useEffect, useRef } from 'react';
import { ContractsReadinessStatus } from '@dealstack/shared/lib/common/business/contracts';
import type { UseAutoPrepareSignableDocumentsArgs } from '@dealstack/frontend/investor/pages/Investment/common/DocumentWorkflowContracts/hooks/useAutoPrepareSignableDocuments.types';

/**
 * Re-runs document preparation on the READY -> NOT_READY edge (e.g. an admin sends
 * a new document), so it becomes signable without a page refresh. Only fires on that
 * edge to avoid a feedback loop and skip the initial NOT_READY. Requires SSE connected.
 */
export const useAutoPrepareSignableDocuments = ({
	enabled,
	status,
	onPrepare,
}: UseAutoPrepareSignableDocumentsArgs): void => {
	const previousStatusRef = useRef<ContractsReadinessStatus | undefined>(undefined);

	useEffect(() => {
		if (!enabled) {
			previousStatusRef.current = status;
			return;
		}

		const previousStatus = previousStatusRef.current;
		previousStatusRef.current = status;

		if (
			previousStatus === ContractsReadinessStatus.READY &&
			status === ContractsReadinessStatus.NOT_READY
		) {
			onPrepare();
		}
	}, [enabled, status, onPrepare]);
};
